'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOAD_UNSCHEDULED_EVENTS_ERROR = exports.LOAD_UNSCHEDULED_EVENTS_SUCCESS = exports.LOAD_UNSCHEDULED_EVENTS_START = exports.DETACH_FROM_STAGE_ERROR = exports.DETACH_FROM_STAGE_SUCCESS = exports.DETACH_FROM_STAGE_START = exports.REATTACH_TO_STAGE_ERROR = exports.REATTACH_TO_STAGE_SUCCESS = exports.REATTACH_TO_STAGE_START = exports.ATTACH_TO_STAGE_ERROR = exports.ATTACH_TO_STAGE_SUCCESS = exports.ATTACH_TO_STAGE_START = exports.UPDATE_STAGE_ERROR = exports.UPDATE_STAGE_SUCCESS = exports.UPDATE_STAGE_START = exports.REMOVE_STAGE_ERROR = exports.REMOVE_STAGE_SUCCESS = exports.REMOVE_STAGE_START = exports.CREATE_STAGE_ERROR = exports.CREATE_STAGE_SUCCESS = exports.CREATE_STAGE_START = exports.SEED_STAGES_ERROR = exports.SEED_STAGES_SUCCESS = exports.SEED_STAGES_START = undefined;

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _dispatcher = require('../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _actionFactory = require('../action-factory');

var _actionFactory2 = _interopRequireDefault(_actionFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moment = require('moment-timezone');

var SEED_STAGES_START = exports.SEED_STAGES_START = 'SEED_STAGES_START';
var SEED_STAGES_SUCCESS = exports.SEED_STAGES_SUCCESS = 'SEED_STAGES_SUCCESS';
var SEED_STAGES_ERROR = exports.SEED_STAGES_ERROR = 'SEED_STAGES_ERROR';
var CREATE_STAGE_START = exports.CREATE_STAGE_START = 'CREATE_STAGE_START';
var CREATE_STAGE_SUCCESS = exports.CREATE_STAGE_SUCCESS = 'CREATE_STAGE_SUCCESS';
var CREATE_STAGE_ERROR = exports.CREATE_STAGE_ERROR = 'CREATE_STAGE_ERROR';
var REMOVE_STAGE_START = exports.REMOVE_STAGE_START = 'REMOVE_STAGE_START';
var REMOVE_STAGE_SUCCESS = exports.REMOVE_STAGE_SUCCESS = 'REMOVE_STAGE_SUCCESS';
var REMOVE_STAGE_ERROR = exports.REMOVE_STAGE_ERROR = 'REMOVE_STAGE_ERROR';
var UPDATE_STAGE_START = exports.UPDATE_STAGE_START = 'UPDATE_STAGE_START';
var UPDATE_STAGE_SUCCESS = exports.UPDATE_STAGE_SUCCESS = 'UPDATE_STAGE_SUCCESS';
var UPDATE_STAGE_ERROR = exports.UPDATE_STAGE_ERROR = 'UPDATE_STAGE_ERROR';
var ATTACH_TO_STAGE_START = exports.ATTACH_TO_STAGE_START = 'ATTACH_TO_STAGE_START';
var ATTACH_TO_STAGE_SUCCESS = exports.ATTACH_TO_STAGE_SUCCESS = 'ATTACH_TO_STAGE_SUCCESS';
var ATTACH_TO_STAGE_ERROR = exports.ATTACH_TO_STAGE_ERROR = 'ATTACH_TO_STAGE_ERROR';
var REATTACH_TO_STAGE_START = exports.REATTACH_TO_STAGE_START = 'REATTACH_TO_STAGE_START';
var REATTACH_TO_STAGE_SUCCESS = exports.REATTACH_TO_STAGE_SUCCESS = 'REATTACH_TO_STAGE_SUCCESS';
var REATTACH_TO_STAGE_ERROR = exports.REATTACH_TO_STAGE_ERROR = 'REATTACH_TO_STAGE_ERROR';
var DETACH_FROM_STAGE_START = exports.DETACH_FROM_STAGE_START = 'DETACH_FROM_STAGE_START';
var DETACH_FROM_STAGE_SUCCESS = exports.DETACH_FROM_STAGE_SUCCESS = 'DETACH_FROM_STAGE_SUCCESS';
var DETACH_FROM_STAGE_ERROR = exports.DETACH_FROM_STAGE_ERROR = 'DETACH_FROM_STAGE_ERROR';
var LOAD_UNSCHEDULED_EVENTS_START = exports.LOAD_UNSCHEDULED_EVENTS_START = 'LOAD_UNSCHEDULED_EVENTS_START';
var LOAD_UNSCHEDULED_EVENTS_SUCCESS = exports.LOAD_UNSCHEDULED_EVENTS_SUCCESS = 'LOAD_UNSCHEDULED_EVENTS_SUCCESS';
var LOAD_UNSCHEDULED_EVENTS_ERROR = exports.LOAD_UNSCHEDULED_EVENTS_ERROR = 'LOAD_UNSCHEDULED_EVENTS_ERROR';

_angular2.default.module('ifeis.stages.actions', ['ifeis.dispatcher', 'ifeis.stages.service', 'ifeis.stages.store']).factory('stageActions', function (dispatcher, fStages, $q) {
  var seedStart = (0, _actionFactory2.default)(dispatcher, SEED_STAGES_START);
  var seedSuccess = (0, _actionFactory2.default)(dispatcher, SEED_STAGES_SUCCESS);
  var seedError = (0, _actionFactory2.default)(dispatcher, SEED_STAGES_ERROR);

  var createStart = (0, _actionFactory2.default)(dispatcher, CREATE_STAGE_START);
  var createSuccess = (0, _actionFactory2.default)(dispatcher, CREATE_STAGE_SUCCESS);
  var createError = (0, _actionFactory2.default)(dispatcher, CREATE_STAGE_ERROR);

  var updateStart = (0, _actionFactory2.default)(dispatcher, UPDATE_STAGE_START);
  var updateSuccess = (0, _actionFactory2.default)(dispatcher, UPDATE_STAGE_SUCCESS);
  var updateError = (0, _actionFactory2.default)(dispatcher, UPDATE_STAGE_ERROR);

  var removeStart = (0, _actionFactory2.default)(dispatcher, REMOVE_STAGE_START);
  var removeSuccess = (0, _actionFactory2.default)(dispatcher, REMOVE_STAGE_SUCCESS);
  var removeError = (0, _actionFactory2.default)(dispatcher, REMOVE_STAGE_ERROR);

  var unscheduledStart = (0, _actionFactory2.default)(dispatcher, LOAD_UNSCHEDULED_EVENTS_START);
  var unscheduledSuccess = (0, _actionFactory2.default)(dispatcher, LOAD_UNSCHEDULED_EVENTS_SUCCESS);
  var unscheduledError = (0, _actionFactory2.default)(dispatcher, LOAD_UNSCHEDULED_EVENTS_ERROR);

  var attachStart = (0, _actionFactory2.default)(dispatcher, ATTACH_TO_STAGE_START);
  var attachSuccess = (0, _actionFactory2.default)(dispatcher, ATTACH_TO_STAGE_SUCCESS);
  var attachError = (0, _actionFactory2.default)(dispatcher, ATTACH_TO_STAGE_ERROR);

  var detachStart = (0, _actionFactory2.default)(dispatcher, DETACH_FROM_STAGE_START);
  var detachSuccess = (0, _actionFactory2.default)(dispatcher, DETACH_FROM_STAGE_SUCCESS);
  var detachError = (0, _actionFactory2.default)(dispatcher, DETACH_FROM_STAGE_ERROR);

  var reattachStart = (0, _actionFactory2.default)(dispatcher, REATTACH_TO_STAGE_START);
  var reattachSuccess = (0, _actionFactory2.default)(dispatcher, REATTACH_TO_STAGE_SUCCESS);
  var reattachError = (0, _actionFactory2.default)(dispatcher, REATTACH_TO_STAGE_ERROR);

  function seed(fid, context) {
    seedStart({ fid: fid }, context);

    var s = fStages.for(fid);
    return s.all().then(function (stages) {
      return $q.all(stages.map(function (stage) {
        return s.one(stage.id).then(function (stg) {
          stg.dt = stages.find(function (sf) {
            return sf.id === stg.id;
          }).dt; // TODO temporary fix until backed returns dt prop for one()
          return stg;
        });
      }));
    }).then(function (stages) {
      return seedSuccess({ fid: fid, stages: stages }, context);
    }).catch(function (err) {
      return seedError(err, context);
    });
  }

  function create(fid, stage, context) {
    createStart({ fid: fid, stage: stage }, context);

    fStages.for(fid).create(stage).then(function (stage) {
      return createSuccess({ fid: fid, stage: stage }, context);
    }).catch(function (err) {
      return createError(err, context);
    });
  }

  function remove(fid, stage, context) {
    removeStart({ fid: fid, stage: stage }, context);

    fStages.for(fid).withStage(stage.id).remove().then(function () {
      return removeSuccess({ fid: fid, stage: stage }, context);
    }).then(function () {
      return loadUnscheduledEvents(fid, context);
    }).catch(function (err) {
      return removeError(err, context);
    });
  }

  function update(fid, stage, context) {
    updateStart({ fid: fid, stage: stage }, context);

    fStages.for(fid).withStage(stage.id).update(stage).then(function (stage) {
      return updateSuccess({ fid: fid, stage: stage }, context);
    }).catch(function (err) {
      return updateError(err, context);
    });
  }

  function loadUnscheduledEvents(fid, context) {
    unscheduledStart({ fid: fid }, context);

    fStages.for(fid).unscheduled().then(function (events) {
      return unscheduledSuccess({ fid: fid, events: events }, context);
    }).catch(function (err) {
      return unscheduledError(err, context);
    });
  }

  function attach(fid, sid, before_id, event, after_id, context) {
    attachStart({ fid: fid, sid: sid, before_id: before_id, after_id: after_id, event: event }, context);

    return fStages.for(fid).withStage(sid).attach(event, before_id, after_id).then(function (stage) {
      return attachSuccess({ fid: fid, stage: stage }, context);
    }).then(function () {
      return loadUnscheduledEvents(fid, context);
    }).catch(function (err) {
      return attachError(err, context);
    });
  }

  function detach(fid, sid, event, context) {
    detachStart({ fid: fid, sid: sid, event: event }, context);

    return fStages.for(fid).withStage(sid).detach(event).then(function (stage) {
      return detachSuccess({ fid: fid, stage: stage }, context);
    }).then(function () {
      return loadUnscheduledEvents(fid, context);
    }).catch(function (err) {
      return detachError(err, context);
    });
  }

  function reattach(fid, from_sid, to_sid, before_id, event, after_id, context) {
    reattachStart({ fid: fid, to_sid: to_sid, from_sid: from_sid, event: event }, context);

    return fStages.for(fid).withStage(from_sid).detach(event).then(function (stage) {
      return detachSuccess({ fid: fid, stage: stage }, context);
    }).then(function () {
      return fStages.for(fid).withStage(to_sid).attach(event, before_id, after_id);
    }).then(function (stage) {
      return attachSuccess({ fid: fid, stage: stage }, context);
    }).then(function () {
      return reattachSuccess({ fid: fid, event: event }, context);
    }).catch(function (err) {
      return reattachError(err, context);
    });
  }

  function prepareFeisDays(feis, feisTz) {
    var feisDtStart = moment(feis.dt_start).tz(feisTz).startOf('day');
    var feisDtEnd = moment(feis.dt_end).tz(feisTz).startOf('day');
    var feisNumDays = feisDtEnd.diff(feisDtStart, 'days') + 1;

    var days = [];
    for (var i = 0; i < feisNumDays; i++) {
      var date = feisDtStart.clone().add(i, 'd');
      days.push({
        date: date.valueOf(),
        title: date.format('MMM D')
      });
    }
    return days;
  }

  return {
    seed: seed,
    loadUnscheduledEvents: loadUnscheduledEvents,

    create: create,
    update: update,
    attach: attach,
    detach: detach,
    reattach: reattach,
    remove: remove,
    prepareFeisDays: prepareFeisDays
  };
});


//////////////////
// WEBPACK FOOTER
// ./stages/actions.js
// module id = 144
// module chunks = 0